import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class LMDrillAroundStateService {

  public saveDrillStateEventSource = new Subject<void>();

  saveDrillStateEvent$ = this.saveDrillStateEventSource.asObservable();

  fireSaveDrillStateEvent() {
    this.saveDrillStateEventSource.next();
  }
}
